var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00014 19.6H4.60014V6.28002H1.00014V19.6ZM2.80014 0.400024C1.60014 0.400024 0.640137 1.36002 0.640137 2.56002C0.640137 3.76002 1.60014 4.72002 2.80014 4.72002C4.00014 4.72002 4.96014 3.76002 4.96014 2.56002C4.96014 1.36002 4.00014 0.400024 2.80014 0.400024ZM10.7201 8.32002V6.28002H7.12014V19.6H10.7201V12.76C10.7201 8.92002 15.6401 8.68002 15.6401 12.76V19.6H19.2401V11.44C19.2401 4.96002 12.4001 5.20002 10.7201 8.32002Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.7c4f8029a8312f9b39ced3d0e5d5b5c6.svg";
export { ForwardRef as ReactComponent };